import type { PublicProduct } from '@/types/checkout'
import type { PricingMode } from '@/types/points'
import { isFreePrice } from '@/lib/products/kinds'

/** F-160: how the product is paid; MONEY when the server says nothing. */
export const pricingModeOf = (product: Pick<PublicProduct, 'pricingMode'>): PricingMode => product.pricingMode ?? 'MONEY'

/** Points-only never comes out free: the server's `free` decides, then the money price for older payloads. */
export const isFreeProduct = (product: Pick<PublicProduct, 'free' | 'price' | 'pricingMode'>): boolean =>
  typeof product.free === 'boolean' ? product.free : pricingModeOf(product) !== 'POINTS' && isFreePrice(product.price)

/** Takes points: POINTS or POINTS_OR_MONEY, with a price. */
export const takesPoints = (product: Pick<PublicProduct, 'pricingMode' | 'pointsPrice'>): boolean =>
  pricingModeOf(product) !== 'MONEY' && Number(product.pointsPrice) > 0

/** Takes money: MONEY or POINTS_OR_MONEY. */
export const takesMoney = (product: Pick<PublicProduct, 'pricingMode'>): boolean => pricingModeOf(product) !== 'POINTS'

/** The viewer can pay this with points right now (balance on, signed in): the server's `pointsAvailable`. */
export const pointsUsable = (product: Pick<PublicProduct, 'pointsAvailable'>): boolean => product.pointsAvailable === true

/** Takes points, usable, and nothing missing: the redeem button is live. */
export const canRedeemNow = (product: Pick<PublicProduct, 'pricingMode' | 'pointsPrice' | 'pointsAvailable' | 'pointsShortfall'>): boolean =>
  takesPoints(product) && pointsUsable(product) && !(Number(product.pointsShortfall) > 0)
